// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"vue_routes_Dashboard_vue":"c4aed98871e57a6b8517","vue_routes_templates_TemplatesList_vue":"14f98f2394f9e9076623","vue_routes_templates_TemplateEditor_vue":"0967935e2e41054466b6"}[chunkId] + ".js";
};